var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"post-feed-wrappe"},[_c('section',{staticClass:"post-feed",class:_vm.showGuide ? 'guide-post' : '',style:({
    height: _vm.imgAdaptedHeight
  })},[_c('img-fetched',{staticClass:"post-img",attrs:{"src":_vm.post_image_src,"default-img":_vm.placeHolder,"default-img-width":46}})],1),_c('p',{staticClass:"name"},[_vm._v("@"+_vm._s(_vm.userName))])])}
var staticRenderFns = []

export { render, staticRenderFns }